import { ProductGridElementDataType } from '@/components/sections/builder/elements/body/collection-product-grid/type';
import ElementContent from '@/components/sections/builder/elements/body/collection-product-grid/content';
import ElementSetting from '@/components/sections/builder/elements/body/collection-product-grid/setting';
import { BetweenHorizontalStart } from 'lucide-react';

const defaultData: ProductGridElementDataType = {
  name: 'Product Grid',
  limit: 16,
  totalCol: 4,
  totalColMobile: 1,
  imageRatio: 'square',
  showSecondImageOnHover: false,
  showProductRating: false,
  enableFilter: false,
  enableSort: false,
  enableQuickAddButton: false,
  filterLayout: 'vertical',
  padding: {
    top: 15,
    bottom: 15,
    left: 0,
    right: 0,
  },
  contentAlign: 'left',
  size: 'small',
  showCategory: true,
  showFilterCategory: true,
  showFilterAvailability: true,
  showFilterPrice: true,
};

export const ElementPreviewIcon = BetweenHorizontalStart;

const ProductGrid = {
  type: 'product_grid',
  group: 'body_collections',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  isImmutable: true,
  maxEntries: 1,
};

export default ProductGrid;
